import styled from 'styled-components';
import { mediaMax } from '../../../../styles/mediaQueries';

export const MapWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${mediaMax.tabletLandscape`
    flex-wrap: wrap;
  `};
`;

export const MapNav = styled.div`
  width: 300px;
  padding: 0;
  ${mediaMax.tabletLandscape`
    width:60%;
  `};
  ${mediaMax.tablet`
    width:100%;
  `};
`;

export const MapItemsCategories = styled.div`
  ul {
    padding: 26px 0 24px 0;
    margin: 0;

    li:first-child {
      border-top: 2px solid rgba(0, 0, 0, 0.2);
    }
    li {
      padding: 10px 0 8px;
      font-size: 21px;
      line-height: 21px;
      letter-spacing: -0.3px;
      list-style: none;
      color: #000;
      border-bottom: 2px solid rgba(0, 0, 0, 0.2);
      span {
        font-family: 'SangBleu Kingdom', sans-serif;
        display: block;
        cursor: pointer;
      }
      &.active {
        height: auto;
      }
      &:hover {
        color: #535d53;
      }
    }
  }
`;
export const NavItemsList = styled.div`
  font-size: 10px;
  font-weight: 400;
  margin: 0;
  //display: flex;
  //justify-content: space-between;
  //flex-wrap: wrap;
  column-count: 2;
  padding: 10px 0;

  p {
    display: flex;
    align-items: center;
    width: 100%;
    list-style: none;
    position: relative;
    padding: 0 10px 0 0;
    margin: 0 0 6px 0;
    line-height: 14px;
    letter-spacing: 0;
    color: #000;
    transition: 0.25s ease-out;
    cursor: pointer;

    ${mediaMax.tabletLandscape`
      text-transform: unset;
      padding: 1px 20px 2px 0;
    `};
    &:before {
      padding-right: 1px;
      margin-right: 8px;
      content: attr(data-id);
      width: 13px;
      height: 13px;
      font-size: 8px;
      line-height: 8px;
      border-radius: 50%;
      background-color: #000;
      color: white;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      color: #9aa49a;
    }
  }
`;

export const MapContainer = styled.div`
  padding-top: 26px;
  width: calc(100% - 360px);
  height: 78vh;
  ${mediaMax.tabletLandscape`
    width: 100%;
    height: 75vh;
    margin: 50px 0;
  `};
  ${mediaMax.phoneXL`
    width: 100%;
    height: 42.5vh;
    margin-top: 0;
    margin-bottom: 24px;
  `};
  .mapboxgl-popup-content {
    background: #000;
    color: white;
    padding: 5px 10px;
    line-height: 1.1em;
    max-width: 240px;
    text-align: center;
    border-radius: 0;
    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 53%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid rgba(0, 0, 0, 0.6);
      z-index: 1;
    }
  }
  .mapboxgl-popup-tip {
    border-top-color: #9aa49a;
    margin-left: 10px;
    opacity: 0.6;
  }
  .mapboxgl-popup-close-button {
    color: white;
    font-family: sans-serif;
  }
  .mapboxgl-ctrl-bottom-left,
  .mapboxgl-ctrl-bottom-right {
    display: none;
  }
  .mapboxgl-ctrl-group {
    background-color: #000;
  }
  .mapboxgl-ctrl-zoom-in {
    transition: 0.25s ease-out;
    span {
      background-image: url(data:image/svg+xml;charset=utf8,<svg%20viewBox%3D%270%200%2020%2020%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27>%0A%20%20<path%20style%3D%27fill%3A%23fff%3B%27%20d%3D%27M%2010%206%20C%209.446%206%209%206.4459904%209%207%20L%209%209%20L%207%209%20C%206.446%209%206%209.446%206%2010%20C%206%2010.554%206.446%2011%207%2011%20L%209%2011%20L%209%2013%20C%209%2013.55401%209.446%2014%2010%2014%20C%2010.554%2014%2011%2013.55401%2011%2013%20L%2011%2011%20L%2013%2011%20C%2013.554%2011%2014%2010.554%2014%2010%20C%2014%209.446%2013.554%209%2013%209%20L%2011%209%20L%2011%207%20C%2011%206.4459904%2010.554%206%2010%206%20z%27%20%2F>%0A<%2Fsvg>%0A) !important;
    }
    &:hover {
      opacity: 0.75;
    }
  }
  .mapboxgl-ctrl-zoom-out {
    transition: 0.25s ease-out;
    span {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='white'%3E %3Cpath d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-9z'/%3E %3C/svg%3E") !important;
    }
    &:hover {
      opacity: 0.75;
    }
  }
`;
export const MapMarker = styled.div`
  width: 16px;
  height: 16px;
  cursor: pointer;
  top: 0;
  left: 0;
  span {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &.shop {
      background-color: #bc8f8b;
    }
    &.dine {
      background-color: #8ea6b2;
    }
    &.work {
      background-color: #231f21;
    }
    &.live {
      background-color: #7b7463;
    }
    padding-top: 1px;
    color: #f2f2f2;
    font-family: 'Apercu', 'sans-serif';
    font-size: 10px;
    line-height: 10px;
    letter-spacing: -0.3px;
  }
`;
export const PopupMapItemName = styled.h3`
  font: 14px/14px Helvetica Neue, Arial, Helvetica, sans-serif;
  font-weight: 700;
  letter-spacing: normal;
  padding: 0 !important;
`;

export const PopupMapItemAddress = styled.p`
  font: 12px/13px Helvetica Neue, Arial, Helvetica, sans-serif !important;
  padding: 0 !important;
  letter-spacing: normal;
  p {
    padding: 0 !important;
  }
`;
